export default __webpack_public_path__ + "static/media/left-arrow-icon.3f39fa8b.svg";